// src/course.dto.ts
var CourseType = /* @__PURE__ */ ((CourseType2) => {
  CourseType2["ONLINE_SELF_PACED"] = "ONLINE_SELF_PACED";
  CourseType2["ONLINE_LIVE"] = "ONLINE_LIVE";
  CourseType2["OFFLINE"] = "OFFLINE";
  CourseType2["HYBRID"] = "HYBRID";
  return CourseType2;
})(CourseType || {});
var CourseEnrollmentStatus = /* @__PURE__ */ ((CourseEnrollmentStatus2) => {
  CourseEnrollmentStatus2["PENDING"] = "PENDING";
  CourseEnrollmentStatus2["ACTIVE"] = "ACTIVE";
  CourseEnrollmentStatus2["COMPLETED"] = "COMPLETED";
  CourseEnrollmentStatus2["CANCELLED"] = "CANCELLED";
  CourseEnrollmentStatus2["PARTIALLY_PAID"] = "PARTIALLY_PAID";
  return CourseEnrollmentStatus2;
})(CourseEnrollmentStatus || {});
var RenewalType = /* @__PURE__ */ ((RenewalType2) => {
  RenewalType2["AUTOMATIC"] = "AUTOMATIC";
  RenewalType2["MANUAL"] = "MANUAL";
  RenewalType2["ADMIN"] = "ADMIN";
  return RenewalType2;
})(RenewalType || {});
var CourseRelationshipType = /* @__PURE__ */ ((CourseRelationshipType2) => {
  CourseRelationshipType2["COMBO"] = "COMBO";
  CourseRelationshipType2["ADDON"] = "ADDON";
  CourseRelationshipType2["PREREQUISITE"] = "PREREQUISITE";
  CourseRelationshipType2["RELATED"] = "RELATED";
  return CourseRelationshipType2;
})(CourseRelationshipType || {});
var RenewalStatus = /* @__PURE__ */ ((RenewalStatus2) => {
  RenewalStatus2["INITIATED"] = "INITIATED";
  RenewalStatus2["PENDING"] = "PENDING";
  RenewalStatus2["PENDING_PAYMENT"] = "PENDING_PAYMENT";
  RenewalStatus2["COMPLETED"] = "COMPLETED";
  RenewalStatus2["FAILED"] = "FAILED";
  RenewalStatus2["CANCELLED"] = "CANCELLED";
  return RenewalStatus2;
})(RenewalStatus || {});

// src/hub.dto.ts
var HubEnrollmentStatus = /* @__PURE__ */ ((HubEnrollmentStatus2) => {
  HubEnrollmentStatus2["ACTIVE"] = "ACTIVE";
  HubEnrollmentStatus2["EXPIRED"] = "EXPIRED";
  HubEnrollmentStatus2["CANCELLED"] = "CANCELLED";
  HubEnrollmentStatus2["PENDING"] = "PENDING";
  HubEnrollmentStatus2["FAILED"] = "FAILED";
  return HubEnrollmentStatus2;
})(HubEnrollmentStatus || {});

// src/live-event.dto.ts
var LiveEventType = /* @__PURE__ */ ((LiveEventType2) => {
  LiveEventType2["COMPETITION"] = "COMPETITION";
  LiveEventType2["WORKSHOP"] = "WORKSHOP";
  LiveEventType2["SEMINAR"] = "SEMINAR";
  LiveEventType2["CONFERENCE"] = "CONFERENCE";
  LiveEventType2["WEBINAR"] = "WEBINAR";
  LiveEventType2["MEETUP"] = "MEETUP";
  LiveEventType2["OTHER"] = "OTHER";
  return LiveEventType2;
})(LiveEventType || {});
var LiveEventStatus = /* @__PURE__ */ ((LiveEventStatus2) => {
  LiveEventStatus2["DRAFT"] = "DRAFT";
  LiveEventStatus2["UPCOMING"] = "UPCOMING";
  LiveEventStatus2["ONGOING"] = "ONGOING";
  LiveEventStatus2["COMPLETED"] = "COMPLETED";
  LiveEventStatus2["CANCELLED"] = "CANCELLED";
  return LiveEventStatus2;
})(LiveEventStatus || {});
var LiveEventBookingStatus = /* @__PURE__ */ ((LiveEventBookingStatus2) => {
  LiveEventBookingStatus2["PENDING"] = "PENDING";
  LiveEventBookingStatus2["CONFIRMED"] = "CONFIRMED";
  LiveEventBookingStatus2["CANCELLED"] = "CANCELLED";
  LiveEventBookingStatus2["ATTENDED"] = "ATTENDED";
  LiveEventBookingStatus2["NO_SHOW"] = "NO_SHOW";
  return LiveEventBookingStatus2;
})(LiveEventBookingStatus || {});
var KitDeliveryStatus = /* @__PURE__ */ ((KitDeliveryStatus2) => {
  KitDeliveryStatus2["NOT_APPLICABLE"] = "NOT_APPLICABLE";
  KitDeliveryStatus2["PENDING"] = "PENDING";
  KitDeliveryStatus2["SHIPPED"] = "SHIPPED";
  KitDeliveryStatus2["DELIVERED"] = "DELIVERED";
  KitDeliveryStatus2["FAILED"] = "FAILED";
  return KitDeliveryStatus2;
})(KitDeliveryStatus || {});

// src/media-asset.dto.ts
var TranscodingStatus = /* @__PURE__ */ ((TranscodingStatus2) => {
  TranscodingStatus2["PENDING"] = "PENDING";
  TranscodingStatus2["PROCESSING"] = "PROCESSING";
  TranscodingStatus2["COMPLETED"] = "COMPLETED";
  TranscodingStatus2["FAILED"] = "FAILED";
  return TranscodingStatus2;
})(TranscodingStatus || {});
var CommentType = /* @__PURE__ */ ((CommentType2) => {
  CommentType2["TEXT"] = "TEXT";
  CommentType2["MEDIA"] = "MEDIA";
  CommentType2["TEXT_WITH_MEDIA"] = "TEXT_WITH_MEDIA";
  return CommentType2;
})(CommentType || {});

// src/notification.ts
var NotificationType = /* @__PURE__ */ ((NotificationType2) => {
  NotificationType2["PUSH"] = "push";
  NotificationType2["EMAIL"] = "email";
  NotificationType2["SMS"] = "sms";
  NotificationType2["WHATSAPP"] = "whatsapp";
  NotificationType2["IN_APP"] = "in_app";
  return NotificationType2;
})(NotificationType || {});
var NotificationPriority = /* @__PURE__ */ ((NotificationPriority2) => {
  NotificationPriority2["LOW"] = "low";
  NotificationPriority2["MEDIUM"] = "medium";
  NotificationPriority2["HIGH"] = "high";
  return NotificationPriority2;
})(NotificationPriority || {});

// src/offer.dto.ts
var DiscountType = /* @__PURE__ */ ((DiscountType2) => {
  DiscountType2["PERCENTAGE"] = "PERCENTAGE";
  DiscountType2["FIXED_AMOUNT"] = "FIXED_AMOUNT";
  return DiscountType2;
})(DiscountType || {});
var OfferScope = /* @__PURE__ */ ((OfferScope2) => {
  OfferScope2["GLOBAL"] = "GLOBAL";
  OfferScope2["COURSE"] = "COURSE";
  OfferScope2["RENEWAL"] = "RENEWAL";
  OfferScope2["BOGO"] = "BOGO";
  return OfferScope2;
})(OfferScope || {});
var OfferType = /* @__PURE__ */ ((OfferType2) => {
  OfferType2["DISCOUNT"] = "DISCOUNT";
  OfferType2["BOGO"] = "BOGO";
  OfferType2["BUNDLE"] = "BUNDLE";
  OfferType2["LOYALTY"] = "LOYALTY";
  OfferType2["REFERRAL"] = "REFERRAL";
  return OfferType2;
})(OfferType || {});

// src/online-course.dto.ts
var CourseLevel = /* @__PURE__ */ ((CourseLevel2) => {
  CourseLevel2["BEGINNER"] = "BEGINNER";
  CourseLevel2["INTERMEDIATE"] = "INTERMEDIATE";
  CourseLevel2["ADVANCED"] = "ADVANCED";
  CourseLevel2["EXPERT"] = "EXPERT";
  return CourseLevel2;
})(CourseLevel || {});
var LectureType = /* @__PURE__ */ ((LectureType2) => {
  LectureType2["VIDEO"] = "VIDEO";
  LectureType2["PDF"] = "PDF";
  LectureType2["QUIZ"] = "QUIZ";
  LectureType2["ASSIGNMENT"] = "ASSIGNMENT";
  LectureType2["TEXT"] = "TEXT";
  return LectureType2;
})(LectureType || {});
var ProgressStatus = /* @__PURE__ */ ((ProgressStatus2) => {
  ProgressStatus2["NOT_STARTED"] = "NOT_STARTED";
  ProgressStatus2["IN_PROGRESS"] = "IN_PROGRESS";
  ProgressStatus2["COMPLETED"] = "COMPLETED";
  return ProgressStatus2;
})(ProgressStatus || {});

// src/payment.dto.ts
var PaymentStatus = /* @__PURE__ */ ((PaymentStatus2) => {
  PaymentStatus2["PENDING"] = "PENDING";
  PaymentStatus2["AUTHORIZED"] = "AUTHORIZED";
  PaymentStatus2["COMPLETED"] = "COMPLETED";
  PaymentStatus2["FAILED"] = "FAILED";
  PaymentStatus2["REFUNDED"] = "REFUNDED";
  PaymentStatus2["CANCELLED"] = "CANCELLED";
  return PaymentStatus2;
})(PaymentStatus || {});
var PaymentGroupStatus = /* @__PURE__ */ ((PaymentGroupStatus2) => {
  PaymentGroupStatus2["PARTIALLY_PAID"] = "PARTIALLY_PAID";
  PaymentGroupStatus2["FULLY_PAID"] = "FULLY_PAID";
  PaymentGroupStatus2["PENDING"] = "PENDING";
  PaymentGroupStatus2["OVERDUE"] = "OVERDUE";
  PaymentGroupStatus2["REFUNDED"] = "REFUNDED";
  return PaymentGroupStatus2;
})(PaymentGroupStatus || {});
var PaymentType = /* @__PURE__ */ ((PaymentType2) => {
  PaymentType2["FULL_PAYMENT"] = "FULL_PAYMENT";
  PaymentType2["PARTIAL_PAYMENT"] = "PARTIAL_PAYMENT";
  return PaymentType2;
})(PaymentType || {});
var PaymentPurpose = /* @__PURE__ */ ((PaymentPurpose2) => {
  PaymentPurpose2["COURSE_ENROLLMENT"] = "COURSE_ENROLLMENT";
  PaymentPurpose2["HUB_ENROLLMENT"] = "HUB_ENROLLMENT";
  PaymentPurpose2["COURSE_RENEWAL"] = "COURSE_RENEWAL";
  PaymentPurpose2["COURSE_INSTALLMENT"] = "COURSE_INSTALLMENT";
  PaymentPurpose2["COURSE_SUPPORT_EXTENSION"] = "COURSE_SUPPORT_EXTENSION";
  PaymentPurpose2["LIVE_EVENT_BOOKING"] = "LIVE_EVENT_BOOKING";
  PaymentPurpose2["LIVE_EVENT_BOOKING_INSTALLMENT"] = "LIVE_EVENT_BOOKING_INSTALLMENT";
  PaymentPurpose2["OTHER"] = "OTHER";
  return PaymentPurpose2;
})(PaymentPurpose || {});
var PaymentMethod = /* @__PURE__ */ ((PaymentMethod2) => {
  PaymentMethod2["ONLINE"] = "ONLINE";
  PaymentMethod2["CASH"] = "CASH";
  PaymentMethod2["BANK_TRANSFER"] = "BANK_TRANSFER";
  PaymentMethod2["CHECK"] = "CHECK";
  PaymentMethod2["OTHER"] = "OTHER";
  return PaymentMethod2;
})(PaymentMethod || {});

// src/permissions.enum.ts
var PermissionEnum = /* @__PURE__ */ ((PermissionEnum2) => {
  PermissionEnum2["USER_READ"] = "users:read";
  PermissionEnum2["USER_WRITE"] = "users:write";
  PermissionEnum2["USER_UPDATE"] = "users:update";
  PermissionEnum2["USER_DELETE"] = "users:delete";
  PermissionEnum2["USER_READ_ALL"] = "users:readAll";
  PermissionEnum2["COURSE_READ"] = "courses:read";
  PermissionEnum2["COURSE_WRITE"] = "courses:write";
  PermissionEnum2["COURSE_UPDATE"] = "courses:update";
  PermissionEnum2["COURSE_DELETE"] = "courses:delete";
  PermissionEnum2["COURSE_READ_ALL"] = "courses:readAll";
  PermissionEnum2["COURSE_BATCH_READ"] = "course-batches:read";
  PermissionEnum2["COURSE_BATCH_WRITE"] = "course-batches:write";
  PermissionEnum2["COURSE_BATCH_UPDATE"] = "course-batches:update";
  PermissionEnum2["COURSE_BATCH_DELETE"] = "course-batches:delete";
  PermissionEnum2["COURSE_BATCH_READ_ALL"] = "course-batches:readAll";
  PermissionEnum2["OFFER_READ"] = "offers:read";
  PermissionEnum2["OFFER_WRITE"] = "offers:write";
  PermissionEnum2["OFFER_UPDATE"] = "offers:update";
  PermissionEnum2["OFFER_DELETE"] = "offers:delete";
  PermissionEnum2["OFFER_READ_ALL"] = "offers:readAll";
  PermissionEnum2["COURSE_ENROLLMENT_READ"] = "course-enrollments:read";
  PermissionEnum2["COURSE_ENROLLMENT_WRITE"] = "course-enrollments:write";
  PermissionEnum2["COURSE_ENROLLMENT_UPDATE"] = "course-enrollments:update";
  PermissionEnum2["COURSE_ENROLLMENT_DELETE"] = "course-enrollments:delete";
  PermissionEnum2["COURSE_ENROLLMENT_READ_ALL"] = "course-enrollments:readAll";
  PermissionEnum2["PAYMENT_PLAN_READ"] = "payment-plans:read";
  PermissionEnum2["PAYMENT_PLAN_WRITE"] = "payment-plans:write";
  PermissionEnum2["PAYMENT_PLAN_UPDATE"] = "payment-plans:update";
  PermissionEnum2["PAYMENT_PLAN_DELETE"] = "payment-plans:delete";
  PermissionEnum2["PAYMENT_PLAN_READ_ALL"] = "payment-plans:readAll";
  PermissionEnum2["PAYMENT_READ"] = "payments:read";
  PermissionEnum2["PAYMENT_WRITE"] = "payments:write";
  PermissionEnum2["PAYMENT_UPDATE"] = "payments:update";
  PermissionEnum2["PAYMENT_DELETE"] = "payments:delete";
  PermissionEnum2["PAYMENT_READ_ALL"] = "payments:readAll";
  PermissionEnum2["INSTITUTION_LOCATION_READ"] = "institution-locations:read";
  PermissionEnum2["INSTITUTION_LOCATION_WRITE"] = "institution-locations:write";
  PermissionEnum2["INSTITUTION_LOCATION_UPDATE"] = "institution-locations:update";
  PermissionEnum2["INSTITUTION_LOCATION_DELETE"] = "institution-locations:delete";
  PermissionEnum2["INSTITUTION_LOCATION_READ_ALL"] = "institution-locations:readAll";
  PermissionEnum2["HUB_FEATURE_READ"] = "hub-features:read";
  PermissionEnum2["HUB_FEATURE_WRITE"] = "hub-features:write";
  PermissionEnum2["HUB_FEATURE_UPDATE"] = "hub-features:update";
  PermissionEnum2["HUB_FEATURE_DELETE"] = "hub-features:delete";
  PermissionEnum2["HUB_FEATURE_READ_ALL"] = "hub-features:readAll";
  PermissionEnum2["HUB_PLAN_READ"] = "hub-plans:read";
  PermissionEnum2["HUB_PLAN_WRITE"] = "hub-plans:write";
  PermissionEnum2["HUB_PLAN_UPDATE"] = "hub-plans:update";
  PermissionEnum2["HUB_PLAN_DELETE"] = "hub-plans:delete";
  PermissionEnum2["HUB_PLAN_READ_ALL"] = "hub-plans:readAll";
  PermissionEnum2["HUB_ENROLLMENT_READ"] = "hub-enrollments:read";
  PermissionEnum2["HUB_ENROLLMENT_WRITE"] = "hub-enrollments:write";
  PermissionEnum2["HUB_ENROLLMENT_UPDATE"] = "hub-enrollments:update";
  PermissionEnum2["HUB_ENROLLMENT_DELETE"] = "hub-enrollments:delete";
  PermissionEnum2["HUB_ENROLLMENT_READ_ALL"] = "hub-enrollments:readAll";
  PermissionEnum2["HUB_USAGE_READ"] = "hub-usage:read";
  PermissionEnum2["HUB_USAGE_WRITE"] = "hub-usage:write";
  PermissionEnum2["HUB_USAGE_UPDATE"] = "hub-usage:update";
  PermissionEnum2["HUB_USAGE_DELETE"] = "hub-usage:delete";
  PermissionEnum2["HUB_USAGE_READ_ALL"] = "hub-usage:readAll";
  PermissionEnum2["HUB_HOUR_ADJUSTMENT_READ"] = "hub-hour-adjustments:read";
  PermissionEnum2["HUB_HOUR_ADJUSTMENT_WRITE"] = "hub-hour-adjustments:write";
  PermissionEnum2["HUB_HOUR_ADJUSTMENT_UPDATE"] = "hub-hour-adjustments:update";
  PermissionEnum2["HUB_HOUR_ADJUSTMENT_DELETE"] = "hub-hour-adjustments:delete";
  PermissionEnum2["HUB_HOUR_ADJUSTMENT_READ_ALL"] = "hub-hour-adjustments:readAll";
  PermissionEnum2["HUB_TIER_READ"] = "hub-tiers:read";
  PermissionEnum2["HUB_TIER_WRITE"] = "hub-tiers:write";
  PermissionEnum2["HUB_TIER_UPDATE"] = "hub-tiers:update";
  PermissionEnum2["HUB_TIER_DELETE"] = "hub-tiers:delete";
  PermissionEnum2["HUB_TIER_READ_ALL"] = "hub-tiers:readAll";
  PermissionEnum2["INSTITUTION_STAFF_READ"] = "institution-staff:read";
  PermissionEnum2["INSTITUTION_STAFF_WRITE"] = "institution-staff:write";
  PermissionEnum2["INSTITUTION_STAFF_UPDATE"] = "institution-staff:update";
  PermissionEnum2["INSTITUTION_STAFF_DELETE"] = "institution-staff:delete";
  PermissionEnum2["INSTITUTION_STAFF_READ_ALL"] = "institution-staff:readAll";
  PermissionEnum2["ROLE_READ"] = "roles:read";
  PermissionEnum2["ROLE_WRITE"] = "roles:write";
  PermissionEnum2["ROLE_UPDATE"] = "roles:update";
  PermissionEnum2["ROLE_DELETE"] = "roles:delete";
  PermissionEnum2["ROLE_READ_ALL"] = "roles:readAll";
  PermissionEnum2["MEDIA_ASSET_READ"] = "media-assets:read";
  PermissionEnum2["MEDIA_ASSET_WRITE"] = "media-assets:write";
  PermissionEnum2["MEDIA_ASSET_UPDATE"] = "media-assets:update";
  PermissionEnum2["MEDIA_ASSET_DELETE"] = "media-assets:delete";
  PermissionEnum2["MEDIA_ASSET_READ_ALL"] = "media-assets:readAll";
  PermissionEnum2["ONLINE_COURSE_READ"] = "online-courses:read";
  PermissionEnum2["ONLINE_COURSE_WRITE"] = "online-courses:write";
  PermissionEnum2["ONLINE_COURSE_UPDATE"] = "online-courses:update";
  PermissionEnum2["ONLINE_COURSE_DELETE"] = "online-courses:delete";
  PermissionEnum2["ONLINE_COURSE_READ_ALL"] = "online-courses:readAll";
  PermissionEnum2["ONLINE_COURSE_SECTION_READ"] = "online-course-sections:read";
  PermissionEnum2["ONLINE_COURSE_SECTION_WRITE"] = "online-course-sections:write";
  PermissionEnum2["ONLINE_COURSE_SECTION_UPDATE"] = "online-course-sections:update";
  PermissionEnum2["ONLINE_COURSE_SECTION_DELETE"] = "online-course-sections:delete";
  PermissionEnum2["ONLINE_COURSE_SECTION_READ_ALL"] = "online-course-sections:readAll";
  PermissionEnum2["ONLINE_COURSE_LECTURE_READ"] = "online-course-lectures:read";
  PermissionEnum2["ONLINE_COURSE_LECTURE_WRITE"] = "online-course-lectures:write";
  PermissionEnum2["ONLINE_COURSE_LECTURE_UPDATE"] = "online-course-lectures:update";
  PermissionEnum2["ONLINE_COURSE_LECTURE_DELETE"] = "online-course-lectures:delete";
  PermissionEnum2["ONLINE_COURSE_LECTURE_READ_ALL"] = "online-course-lectures:readAll";
  PermissionEnum2["ONLINE_COURSE_LECTURE_MATERIAL_READ"] = "online-course-lecture-materials:read";
  PermissionEnum2["ONLINE_COURSE_LECTURE_MATERIAL_WRITE"] = "online-course-lecture-materials:write";
  PermissionEnum2["ONLINE_COURSE_LECTURE_MATERIAL_UPDATE"] = "online-course-lecture-materials:update";
  PermissionEnum2["ONLINE_COURSE_LECTURE_MATERIAL_DELETE"] = "online-course-lecture-materials:delete";
  PermissionEnum2["ONLINE_COURSE_LECTURE_MATERIAL_READ_ALL"] = "online-course-lecture-materials:readAll";
  PermissionEnum2["ONLINE_COURSE_LECTURE_PROGRESS_READ"] = "online-course-lecture-progress:read";
  PermissionEnum2["ONLINE_COURSE_LECTURE_PROGRESS_WRITE"] = "online-course-lecture-progress:write";
  PermissionEnum2["ONLINE_COURSE_LECTURE_PROGRESS_UPDATE"] = "online-course-lecture-progress:update";
  PermissionEnum2["ONLINE_COURSE_LECTURE_PROGRESS_DELETE"] = "online-course-lecture-progress:delete";
  PermissionEnum2["ONLINE_COURSE_LECTURE_PROGRESS_READ_ALL"] = "online-course-lecture-progress:readAll";
  PermissionEnum2["ONLINE_COURSE_DAILY_UNLOCK_READ"] = "online-course-daily-unlocks:read";
  PermissionEnum2["ONLINE_COURSE_DAILY_UNLOCK_WRITE"] = "online-course-daily-unlocks:write";
  PermissionEnum2["ONLINE_COURSE_DAILY_UNLOCK_UPDATE"] = "online-course-daily-unlocks:update";
  PermissionEnum2["ONLINE_COURSE_DAILY_UNLOCK_DELETE"] = "online-course-daily-unlocks:delete";
  PermissionEnum2["ONLINE_COURSE_DAILY_UNLOCK_READ_ALL"] = "online-course-daily-unlocks:readAll";
  PermissionEnum2["ONLINE_COURSE_ANALYTICS_READ"] = "online-course-analytics:read";
  PermissionEnum2["PERMISSION_READ"] = "permissions:read";
  PermissionEnum2["PERMISSION_ASSIGN"] = "permissions:assign";
  PermissionEnum2["LIVE_EVENT_READ"] = "live-events:read";
  PermissionEnum2["LIVE_EVENT_WRITE"] = "live-events:write";
  PermissionEnum2["LIVE_EVENT_UPDATE"] = "live-events:update";
  PermissionEnum2["LIVE_EVENT_DELETE"] = "live-events:delete";
  PermissionEnum2["LIVE_EVENT_READ_ALL"] = "live-events:readAll";
  PermissionEnum2["LIVE_EVENT_BOOKING_READ"] = "live-event-bookings:read";
  PermissionEnum2["LIVE_EVENT_BOOKING_WRITE"] = "live-event-bookings:write";
  PermissionEnum2["LIVE_EVENT_BOOKING_UPDATE"] = "live-event-bookings:update";
  PermissionEnum2["LIVE_EVENT_BOOKING_DELETE"] = "live-event-bookings:delete";
  PermissionEnum2["LIVE_EVENT_BOOKING_READ_ALL"] = "live-event-bookings:readAll";
  PermissionEnum2["LIVE_EVENT_KIT_READ"] = "live-event-kits:read";
  PermissionEnum2["LIVE_EVENT_KIT_WRITE"] = "live-event-kits:write";
  PermissionEnum2["LIVE_EVENT_KIT_UPDATE"] = "live-event-kits:update";
  PermissionEnum2["LIVE_EVENT_KIT_DELETE"] = "live-event-kits:delete";
  PermissionEnum2["LIVE_EVENT_KIT_READ_ALL"] = "live-event-kits:readAll";
  PermissionEnum2["LIVE_EVENT_BOOKING_KIT_ITEM_UPDATE"] = "live-event-booking-kits:update";
  PermissionEnum2["LIVE_EVENT_BOOKING_KIT_ITEM_READ_ALL"] = "live-event-booking-kits:readAll";
  return PermissionEnum2;
})(PermissionEnum || {});
export {
  CommentType,
  CourseEnrollmentStatus,
  CourseLevel,
  CourseRelationshipType,
  CourseType,
  DiscountType,
  HubEnrollmentStatus,
  KitDeliveryStatus,
  LectureType,
  LiveEventBookingStatus,
  LiveEventStatus,
  LiveEventType,
  NotificationPriority,
  NotificationType,
  OfferScope,
  OfferType,
  PaymentGroupStatus,
  PaymentMethod,
  PaymentPurpose,
  PaymentStatus,
  PaymentType,
  PermissionEnum,
  ProgressStatus,
  RenewalStatus,
  RenewalType,
  TranscodingStatus
};
